<template>
    <emp-fp-enroll v-if="enrollVariant" :emp="emp" :variant="enrollVariant"
        @close="enrollVariant = null"></emp-fp-enroll>
    <v-card v-else-if="!!empFpMap">
        <v-card-title>
            <v-row class="ml-3">
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <v-img :max-width="100" :src="emp.img || require('@/assets/imgs/no-img21.png')" />
                </v-col>
                <v-col cols="12" sm="9" class="justify-center d-flex flex-column">
                    <span class="d-flex justify-space-between">
                        <span class="headline-1">{{ emp.name }}</span>
                        <span class="headline-4">{{ emp.cId }}</span>
                    </span>
                    <span class="headline-2">{{ emp.department }}</span>
                    <span class="headline-3">{{ emp.post }}</span>
                    <span class="headline-4">{{ emp.farm }}</span>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <v-row class="pt-6 ga-3">
                <v-col cols="12" sm="6" class="justify-center d-flex flex-column">
                    <span class="text-h5 text-center mb-5">Mano Izquierda</span>
                    <v-row>
                        <v-col cols="6" sm="6" class="d-flex flex-column align-center">
                            <span class="text-h6 mb-3">Pulgar</span>
                            <v-btn elevation="4" icon
                                :class="`big-finger clickable ${empFpMap[FpVariantEnum.l1] ? 'active' : ''}`"
                                @click="onClickVariant(FpVariantEnum.l1)">
                                <v-icon>mdi-fingerprint</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="6" class="d-flex flex-column align-center">
                            <span class="text-h6 mb-3">Indice</span>
                            <v-btn elevation="4" icon
                                :class="`big-finger clickable ${empFpMap[FpVariantEnum.l2] ? 'active' : ''}`"
                                @click="onClickVariant(FpVariantEnum.l2)">
                                <v-icon>mdi-fingerprint</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="6" class="justify-center d-flex flex-column">
                    <span class="text-h5 text-center mb-5">Mano Derecha</span>
                    <v-row>
                        <v-col cols="6" sm="6" class="d-flex flex-column align-center">
                            <span class="text-h6 mb-3">Pulgar</span>
                            <v-btn elevation="4" icon
                                :class="`big-finger clickable ${empFpMap[FpVariantEnum.r1] ? 'active' : ''}`"
                                @click="onClickVariant(FpVariantEnum.r1)">
                                <v-icon>mdi-fingerprint</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="6" class="d-flex flex-column align-center">
                            <span class="text-h6 mb-3">Indice</span>
                            <v-btn elevation="4" icon
                                :class="`big-finger clickable ${empFpMap[FpVariantEnum.r2] ? 'active' : ''}`"
                                @click="onClickVariant(FpVariantEnum.r2)">
                                <v-icon>mdi-fingerprint</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class="pt-10">
            <v-btn color="blue darken-1" text @click="onClose">Salir</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>

<script>
import EmpFpEnroll from './EmpFpEnroll'
import { FpVariantEnum } from '../services/constData';
import { BluetoothFingerprintScanner } from '../services/fp-service';
export default {
    name: 'EmpFpDetails',
    components: {
        EmpFpEnroll
    },
    props: {
        emp: Object
    },
    data() {
        return {
            empFpMap: null,
            FpVariantEnum,
            enrollVariant: null,
        };
    },
    async created() {
        const res = await this.$store.dispatch('loadFpsByEmpId', { empId: this.emp._id });
        this.empFpMap = res.reduce((acc, fp) => {
            acc[fp.variant] = fp;
            return acc;
        }, {});
        this.scanner = new BluetoothFingerprintScanner({ onEnrollmentData: this.onEnrollFp });
    },
    methods: {
        onClickVariant(variant) {
            this.enrollVariant = variant;
        },
        async onEnrollFp(data) {
            this.isScanning = false;
            this.$store.dispatch('saveEmpFp', { empId: this.emp._id, data, variant: FpVariantEnum.l1 });
        },
        onClose() {
            this.$router.push('../')
        },
    },
};
</script>

<style scoped>
/* Add your component-specific styles here */
</style>